import React from 'react';

const StorefrontProfileCustomFields = ({ fields, editedData, setEditedData }) => {
  if (!fields?.length) return null;

  const setField = (id, value) => setEditedData((prev) => ({ ...prev, [id]: value }));

  return (
    <section className="sf-profile__section">
      <h2 className="sf-profile__section-title">Additional information</h2>
      <div className="sf-profile__grid">
        {fields.map((field) => {
          const label = field.label || field.id;
          const id = field.id;
          const value = editedData[id] ?? '';
          const common = {
            id: `sf-custom-${id}`,
            required: Boolean(field.required),
          };

          if (field.type === 'textarea') {
            return (
              <label key={id} className="sf-profile__field sf-profile__field--full">
                <span className="sf-profile__label">
                  {label}
                  {field.required ? <span aria-hidden> *</span> : null}
                </span>
                <textarea
                  {...common}
                  className="sf-profile__textarea"
                  rows={3}
                  value={value}
                  onChange={(e) => setField(id, e.target.value)}
                />
              </label>
            );
          }

          if (field.type === 'number') {
            return (
              <label key={id} className="sf-profile__field">
                <span className="sf-profile__label">{label}</span>
                <input {...common} type="number" className="sf-profile__input" value={value} onChange={(e) => setField(id, e.target.value)} />
              </label>
            );
          }

          if (field.type === 'date') {
            return (
              <label key={id} className="sf-profile__field">
                <span className="sf-profile__label">{label}</span>
                <input {...common} type="date" className="sf-profile__input" value={value} onChange={(e) => setField(id, e.target.value)} />
              </label>
            );
          }

          if (field.type === 'select' && Array.isArray(field.options)) {
            return (
              <label key={id} className="sf-profile__field sf-profile__field--full">
                <span className="sf-profile__label">{label}</span>
                <select {...common} className="sf-profile__select" value={value} onChange={(e) => setField(id, e.target.value)}>
                  <option value="">Select…</option>
                  {field.options.filter(Boolean).map((opt) => (
                    <option key={opt} value={opt}>{opt}</option>
                  ))}
                </select>
              </label>
            );
          }

          if (field.type === 'checkbox') {
            return (
              <label key={id} className="sf-profile__checkbox-row">
                <input
                  type="checkbox"
                  checked={Boolean(value)}
                  onChange={(e) => setField(id, e.target.checked)}
                />
                <span>{label}</span>
              </label>
            );
          }

          return (
            <label key={id} className="sf-profile__field sf-profile__field--full">
              <span className="sf-profile__label">{label}</span>
              <input {...common} type="text" className="sf-profile__input" value={value} onChange={(e) => setField(id, e.target.value)} />
            </label>
          );
        })}
      </div>
    </section>
  );
};

export default StorefrontProfileCustomFields;
